// Accounting Purchases Vuex

import state from './purchaseReturnFixedStates.js'
import * as getters from './purchaseReturnFixedGetters.js'
import * as mutations from './purchaseReturnFixedMutations.js'
import * as actions from './purchaseReturnFixedActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
